import { Button } from "@/components/ui/button";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

type MissedCallEntry = {
	origin?: string | null;
	type?: string | null;
	status?: string | null;
	reason?: string | null;
};

type MissedCallsTableProps = {
	calls?: MissedCallEntry[];
	onAdd: () => void;
};

export function MissedCallsTable({ calls = [], onAdd }: MissedCallsTableProps) {
	return (
		<div className="space-y-3">
			<div className="overflow-hidden rounded-lg border border-border/60 bg-card/70">
				<Table>
					<TableHeader>
						<TableRow className="bg-muted/50">
							<TableHead>Contacto</TableHead>
							<TableHead>Tipo Contacto</TableHead>
							<TableHead>Estado do contacto</TableHead>
							<TableHead>Descrição</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{calls.map((call) => {
							const rowKey = `${call.origin ?? "origin"}-${
								call.type ?? "type"
							}-${call.status ?? "status"}`;
							return (
								<TableRow key={rowKey}>
									<TableCell>{call.origin ?? "-"}</TableCell>
									<TableCell>{call.type ?? "-"}</TableCell>
									<TableCell>{call.status ?? "-"}</TableCell>
									<TableCell>{call.status ?? "-"}</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</div>
			<div>
				<Button size="sm" variant="secondary" onClick={onAdd}>
					Adicionar
				</Button>
			</div>
		</div>
	);
}
